import { getApiUrl } from "./config";

/** User-facing copy when Firebase already has this email (matches backend 409). */
export const FREE_GATEWAY_EMAIL_IN_USE =
  "This email is already in use.";

function isDuplicateEmailMessage(msg) {
  if (typeof msg !== "string") return false;
  return (
    /this email is already in use/i.test(msg) ||
    /account with this email already exists/i.test(msg) ||
    /email already exists/i.test(msg)
  );
}

/**
 * Server-provisioned Free Gateway signup (no client Firebase registration).
 * User receives a welcome email with a generated password, same pattern as Stripe checkout.
 */
export async function submitFreeGatewaySignup(payload) {
  const res = await fetch(`${getApiUrl()}/users/free-gateway`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 503 || data?.code === "EMAIL_DELIVERY_FAILED") {
      const m =
        typeof data?.message === "string" && data.message.trim()
          ? data.message
          : "We could not send your welcome email. Please try again shortly.";
      throw new Error(m);
    }
    if (res.status === 409 || isDuplicateEmailMessage(data?.message)) {
      throw new Error(FREE_GATEWAY_EMAIL_IN_USE);
    }
    const msg =
      data?.message ||
      data?.error ||
      `Signup failed (${res.status})`;
    if (isDuplicateEmailMessage(msg)) {
      throw new Error(FREE_GATEWAY_EMAIL_IN_USE);
    }
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return data;
}
